import { useMemo, useState } from 'react'
import dayjs from 'dayjs'
import { DateRange } from 'react-day-picker'
import { useDebounce } from '@node-space/hooks'
import { SEARCH_INPUT_DEBOUNCE_TIME } from 'constants/General'
import { buildTransactionsQuery } from '../../helpers/cards'

const DEFAULT_DATE_RANGE_MONTHS = 12

const getDefaultDateRange = (): DateRange => ({
  from: dayjs().subtract(DEFAULT_DATE_RANGE_MONTHS, 'month').startOf('day').toDate(),
  to: dayjs().endOf('day').toDate(),
})

export const useCardTransactionsFilters = (customerId: string) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [dateRange, setDateRange] = useState<DateRange>(getDefaultDateRange)

  const debouncedSearchQuery = useDebounce(searchQuery, SEARCH_INPUT_DEBOUNCE_TIME)

  const queryString = useMemo(
    () => buildTransactionsQuery(debouncedSearchQuery, dateRange, customerId),
    [debouncedSearchQuery, dateRange, customerId]
  )

  return {
    searchQuery,
    setSearchQuery,
    dateRange,
    setDateRange,
    queryString,
    isSearching: !!searchQuery,
  }
}
